export default __webpack_public_path__ + "static/media/SWT1200.34I-35663_-21669_0.7a13ab98.jpg";